import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import { defineMessages, FormattedMessage } from 'react-intl'
import { Button, Text, Player } from '../..'
import Wave from './Wave'

import styles from './HomeownerReportVideoSection.module.scss'

const propTypes = {
  className: PropTypes.string
}

const MESSAGES = defineMessages({
  videoTitle: {
    id: 'HomeownerReportVideoSection.videoTitle',
    defaultMessage: 'Homebot Homeowner Testimonial with Kristy Frechette Video'
  }
})

const Row = props => <div className={styles.row} {...props} />

const HomeownerReportVideoSection = ({ className, onClick, intl, ...restProps }) => (
  <div className={classnames(styles.root, className)} {...restProps}>
    <div className={styles.stage}>
      <Wave className={styles.wave} />
      <div className={styles.maxWidth}>
        <Text.Headline>
          <FormattedMessage id='HomeownerReportVideoSection.heading' defaultMessage='Start building wealth' />
        </Text.Headline>
        <Button data-qa='buttonHomeownerReportVideoSection' primary onClick={onClick} className={styles.button}>
          <FormattedMessage id='HomeownerReportVideoSection.CTA' defaultMessage="Let's do this" />
        </Button>
        <Row>
          <div className={styles.video}>
            <Player videoId='xosvykpmnn' title={intl.formatMessage(MESSAGES.videoTitle)} videoType='wistia' />
          </div>
          <div className={styles.testimonial}>
            <Text variant='neutralCool' variantCount='900'>
              <FormattedMessage
                id='HomeownerReportVideoSection.quote'
                defaultMessage='"Homebot gives me reassurance that my equity is growing in the right direction. It gives me options and I know that I made the right decision to buy."'
              />
            </Text>
            <Text className={styles.signature} variant='neutralCool' variantCount='900'>
              <FormattedMessage
                id='HomeownerReportVideoSection.signature'
                defaultMessage='— {name}, Homeowner'
                values={{ name: 'Kristy' }}
              />
            </Text>
          </div>
        </Row>
      </div>
    </div>
  </div>
)

HomeownerReportVideoSection.propTypes = propTypes

export default HomeownerReportVideoSection
